var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"selector"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"selector-option",class:{ 'active' : option.value === _vm.value },on:{"click":function($event){return _vm.select(option)}}},[_vm._v("\n    "+_vm._s(option.text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }